const rankingItems = [
  {
    rank: 1,
    title: '漫长的季节',
    category: '国产剧',
    hot: '987万',
    tag: '口碑神作',
  },
  {
    rank: 2,
    title: '狂飙',
    category: '国产剧',
    hot: '956万',
    tag: '年度爆款',
  },
  {
    rank: 3,
    title: '繁花',
    category: '国产剧',
    hot: '892万',
    tag: '沪上风情',
  },
  {
    rank: 4,
    title: '黑暗荣耀',
    category: '韩剧',
    hot: '834万',
    tag: '复仇爽剧',
  },
  {
    rank: 5,
    title: '奥本海默',
    category: '电影',
    hot: '791万',
    tag: '诺兰新作',
  },
  {
    rank: 6,
    title: '莲花楼',
    category: '国产剧',
    hot: '745万',
    tag: '武侠经典',
  },
  {
    rank: 7,
    title: '鬼灭之刃 锻刀村篇',
    category: '动漫',
    hot: '712万',
    tag: '热血推荐',
  },
];

export default function RankingSection() {
  return (
    <section id="ranking" className="py-12 md:py-16 px-4 md:px-6 bg-background-50">
      <div className="max-w-[1024px] mx-auto">
        <div className="text-center mb-8 md:mb-10">
          <span className="inline-flex items-center gap-1 px-3 py-1 rounded-full bg-accent-500/10 text-accent-400 text-xs font-medium mb-3 whitespace-nowrap">
            <i className="ri-fire-fill text-xs"></i>
            热门排行
          </span>
          <h2 className="text-xl md:text-3xl font-bold text-foreground-100 mb-2">
            热播榜单
          </h2>
          <p className="text-foreground-500 text-sm">全站最受欢迎的影视内容</p>
        </div>

        <div className="space-y-2">
          {rankingItems.map((item, idx) => (
            <div
              key={idx}
              className="flex items-center gap-3 md:gap-4 px-4 py-3 rounded-xl bg-background-100 border border-background-200/70 hover:border-background-300/60 transition-colors cursor-pointer"
            >
              <div
                className={`w-8 h-8 flex items-center justify-center rounded-lg font-bold text-sm flex-shrink-0 ${
                  item.rank === 1
                    ? 'bg-primary-500 text-foreground-50'
                    : item.rank === 2
                      ? 'bg-secondary-500 text-foreground-50'
                      : item.rank === 3
                        ? 'bg-accent-500 text-foreground-50'
                        : 'bg-background-300/50 text-foreground-500'
                }`}
              >
                {item.rank}
              </div>
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2">
                  <span className="text-sm md:text-base font-medium text-foreground-200 truncate">
                    {item.title}
                  </span>
                  <span className="inline-block px-2 py-0.5 rounded-md bg-background-300/50 text-foreground-500 text-xs flex-shrink-0">
                    {item.category}
                  </span>
                </div>
              </div>
              <span className="inline-flex items-center gap-1 px-2 py-1 rounded-full bg-primary-500/10 text-primary-400 text-xs font-medium flex-shrink-0 whitespace-nowrap">
                {item.tag}
              </span>
              <span className="text-foreground-600 text-xs flex-shrink-0 hidden sm:block">
                <i className="ri-eye-line mr-1"></i>
                {item.hot}
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}